import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';

/** 全站语言类型。后端 language 字段与 localStorage 均用此取值。 */
export type AppLanguage = 'zh-CN' | 'en';

/** localStorage 键，与 utils/request.ts 的 X-App-Locale 读取共用 */
export const LANGUAGE_STORAGE_KEY = 'letsfly-lang';

export function isAppLanguage(value: string | null | undefined): value is AppLanguage {
  return value === 'zh-CN' || value === 'en';
}

/** 读取本地偏好；缺失或非法回退 zh-CN */
export function readStoredLanguage(): AppLanguage {
  try {
    const v = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isAppLanguage(v) ? v : 'zh-CN';
  } catch {
    return 'zh-CN';
  }
}

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { translation: zhCN },
      en: { translation: enUS },
    },
    lng: readStoredLanguage(),
    fallbackLng: 'zh-CN',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

/** 同步 <html lang>，保证读屏/浏览器行为与界面语言一致 */
function syncHtmlLang(lng: string): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng === 'en' ? 'en' : 'zh-CN';
  }
}

syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
